import { useState, useCallback } from "react"

type SetValue<T> = (value: T | ((prev: T) => T)) => void

export default function useLocalStorage<T>(
  key: string,
  initialValue: T
): [T, SetValue<T>] {
  const [item, setItem] = useState<T>(() => {
    try {
      const storedItem = window.localStorage.getItem(key)
      return storedItem ? JSON.parse(storedItem) : initialValue
    } catch (error) {
      console.warn(`useLocalStorage: could not read key "${key}"`, error)
      return initialValue
    }
  })

  const setValue: SetValue<T> = useCallback((value) => {
    setItem(prev => {
      const storableValue = value instanceof Function ? value(prev) : value
      try {
        window.localStorage.setItem(key, JSON.stringify(storableValue))
      } catch (error) {
        console.warn(`useLocalStorage: could not write key "${key}"`, error)
      }
      return storableValue
    })
  }, [key])

  return [item, setValue]
}
